var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1127_50015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8418 14.468V20.9002C21.8418 21.4105 21.4266 21.8257 20.9163 21.8257H2.7765C2.26618 21.8257 1.851 21.4105 1.851 20.9002V14.468H0V20.9002C0 22.4311 1.24554 23.6767 2.7765 23.6767H20.9163C22.4473 23.6767 23.6928 22.4311 23.6928 20.9002V14.468H21.8418Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8469 2.53833L6.0957 8.28957L7.40454 9.59841L10.9214 6.08151V16.5002H12.7724V6.08151L16.2893 9.59841L17.5982 8.28957L11.8469 2.53833Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1127_50015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.6928,
    height: 23.6928,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.d1c9618253509d68440c7b05f6d59159.svg";
export { ForwardRef as ReactComponent };